module.exports = __webpack_public_path__ + "static/scenario3-d84c199730c9e262b9dc83c92b96e863.png";